import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1331026f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "company",
  id: "user-info"
}
const _hoisted_2 = { class: "company-data" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "company-contents" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "住所：", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "URL：", -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "代表者：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "業種：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "事業内容：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subtitle = _resolveComponent("subtitle")!
  const _component_user_sns_buttons = _resolveComponent("user-sns-buttons")!
  const _component_company_name = _resolveComponent("company-name")!
  const _component_google_map_view = _resolveComponent("google-map-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_subtitle, {
          icon: "y",
          text: "会社情報"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_company_name, { "user-account": _ctx.userAccount }, {
          default: _withCtx(() => [
            _createVNode(_component_user_sns_buttons, {
              "user-account": _ctx.userAccount,
              "medium-id": _ctx.mediumId
            }, null, 8, ["user-account", "medium-id"])
          ]),
          _: 1
        }, 8, ["user-account"])
      ]),
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            (_ctx.userAccount.isAddressPublishable)
              ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.userAccount.fullAddress()), 1))
              : (_openBlock(), _createElementBlock("td", _hoisted_7, "※発信者の意向により非公開"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                href: _ctx.userAccount.url,
                target: "_blank"
              }, _toDisplayString(_ctx.userAccount.url), 9, _hoisted_9)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.userAccount.delegateName), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_ctx.userAccount.genre), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(_ctx.userAccount.description), 1)
          ])
        ])
      ])
    ]),
    (_ctx.userAccount.isAddressPublishable)
      ? (_openBlock(), _createBlock(_component_google_map_view, {
          key: 0,
          class: "google-map-frame",
          width: 500,
          height: 500,
          address: _ctx.userAccount.fullAddress()
        }, null, 8, ["address"]))
      : _createCommentVNode("", true)
  ]))
}